import { Banner, BlockStack, Modal, Text, TextField } from '@shopify/polaris';
import { useEffect, useState } from 'react';

// Reject with a mandatory reason; Ctrl/Cmd+Enter confirms.
export default function RejectModal({ open, onClose, onConfirm, busy = false, summary }) {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);
  const valid = reason.trim().length >= 3;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Reject document"
      primaryAction={{ content: 'Reject', destructive: true, disabled: !valid, loading: busy, onAction: () => onConfirm(reason.trim()) }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        <div
          onKeyDown={(event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 'Enter' && valid && !busy) onConfirm(reason.trim());
          }}
        >
          <BlockStack gap="300">
            <Banner tone="warning">
              <Text as="p">Rejecting sends the document back to accounting. It will not be paid until it is corrected and approved again.</Text>
              {summary ? <Text as="p">{summary}</Text> : null}
            </Banner>
            <TextField
              label="Reason (required)"
              value={reason}
              onChange={setReason}
              multiline={3}
              autoComplete="off"
              maxLength={500}
              showCharacterCount
              placeholder="Wrong price, goods not received, not ordered by us, ..."
              autoFocus
            />
          </BlockStack>
        </div>
      </Modal.Section>
    </Modal>
  );
}
